import { HttpClient, HttpParams } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { environment } from "../../environments/environment";

@Injectable({
  providedIn: "root",
})
export class MasterService {
  private api = environment.API_URL;
  remoteAPI = "http://192.168.27.59:4003/api";

  private http = inject(HttpClient);

  //#region Get
  getCompanyList() {
    return this.http.get<any>(`${this.api}/company`);
  }

  getLogList() {
    return this.http.get<any>(`${this.api}/company/session-logs`);
  }

  getCompanyDetailsByID(id: number) {
    return this.http.get<any>(`${this.api}/company/${id}`);
  }

  getRegionList(pageno?: number, pagesize?: number, sort?: string) {
    return this.http.get<any>(`${this.api}/region-master?pageno=${pageno}&pagesize=${pagesize}&sort=${sort}`);
  }

  getRegionDetailsByID(id: number) {
    return this.http.get<any>(`${this.api}/region-master/${id}`);
  }

  getCityList(pageno?: number, pagesize?: number, sort?: string) {
    return this.http.get<any>(`${this.api}/city-master?pageno=${pageno}&pagesize=${pagesize}&sort=${sort}`);
  }

  getAreaList(pageno?: number, pagesize?: number, sort?: string) {
    return this.http.get<any>(`${this.api}/area-master?pageno=${pageno}&pagesize=${pagesize}&sort=${sort}`);
  }

  getAreaDetailsByID(id: number) {
    return this.http.get<any>(`${this.api}/area-master/${id}`);
  }

  getCenterList(pageno?: number, pagesize?: number, sort?: string) {
    return this.http.get<any>(`${this.api}/center-master?pageno=${pageno}&pagesize=${pagesize}&sort=${sort}`);
  }

  getCenterSByRegionID(regionID: number) {
    return this.http.get<any>(`${this.api}/center-master/ByRegionID/${regionID}`);
  }

  getCenterSByCityID(cityID: number) {
    return this.http.get<any>(`${this.api}/center-master/ByCityID/${cityID}`);
  }

  getCenterSByAreaID(areaID: number) {
    return this.http.get<any>(`${this.api}/center-master/ByAreaID/${areaID}`);
  }

  getStudentList(pageno?: number, pagesize?: number, sort?: string, CenterIDs?: string, ClassID?: string, TrainerID?: string, search?: string) {
    return this.http.get<any>(`${this.api}/student/students?pageno=${pageno}&pagesize=${pagesize}&sort=${sort}&CenterIDs=${CenterIDs}&ClassID=${ClassID}&TrainerID=${TrainerID}&search=${search}`);
  }

  getBeltList(pageno?: number, pagesize?: number, sort?: string) {
    return this.http.get<any>(`${this.api}/belt-master?pageno=${pageno}&pagesize=${pagesize}&sort=${sort}`);
  }

  getBeltDetailsByID(id: number) {
    return this.http.get<any>(`${this.api}/belt-master/${id}`);
  }

  getStudentRevenue(CenterIDs?: any) {
    return this.http.get<any>(`${this.api}/student/center-revenue?CenterIDs=${CenterIDs}`);
  }

  getStudentInquiries(pageno?: number, pagesize?: number, sort?: string) {
    return this.http.get<any>(`${this.api}/enquiry?pageno=${pageno}&pagesize=${pagesize}&sort=${sort}`);
  }

  getStudentByID(id: any) {
    return this.http.get<any>(`${this.api}/student/${id}`);
  }

  getStudentAttendence(ClassID: any, AttendanceDate: any) {
    return this.http.get<any>(`${this.api}/student/AttendanceList?ClassID=${ClassID}&AttendanceDate=${AttendanceDate}`);
  }

  getStudentAttendenceAll(StudentID: number) {
    return this.http.get<any>(`${this.api}/student/AttendanceListofMonth?StudentID=${StudentID}`);
  }

  getStudentAttendenceReport(StartDate: string, EndDate: string, CenterID?: string, ClassID?: string, StudentID?: string, TrainerID?: string) {
    return this.http.get<any>(
      `${this.api}/student/download-attendance-report?StartDate=${StartDate}&EndDate=${EndDate}&CenterID=${CenterID}&ClassID=${ClassID}&StudentID=${StudentID}&TrainerID=${TrainerID}`
    );
  }

  getStudentInquiryReport(FromDate: string, ToDate: string) {
    return this.http.get<any>(`${this.api}/enquiry/download-report?FromDate=${FromDate}&ToDate=${ToDate}`);
  }

  getStudentPerformanceReport(StudentID: number) {
    return this.http.get<any>(`${this.api}/student-performance/download-report?StudentID=${StudentID}`);
  }

  getStudentAttendanceWeekly(ClassID: number, AttendanceDate: string) {
    return this.http.get<any>(`${this.api}/student/AttendanceListofWeek?ClassID=${ClassID}&AttendanceDate=${AttendanceDate}`);
  }

  getStudentExpiryDetails(CenterIDs: any) {
    return this.http.get<any>(`${this.api}/student/package-expiry-details?CenterIDs=${CenterIDs}`);
  }

  getStudentBalance(studentId: any) {
    return this.http.get<any>(`${this.api}/payment/balance/${studentId}`);
  }

  getStudentPendingBalance(studentId: any) {
    return this.http.get<any>(`${this.api}/student-package-subscription/pending-payments/${studentId}`);
  }

  getCoachList(pageno?: number, pagesize?: number, sort?: string, CenterIDs?: string, UserTypeID?: string, ClassID?: string, StudentID?: string, search?: string) {
    return this.http.get<any>(
      `${this.api}/trainer?pageno=${pageno}&pagesize=${pagesize}&sort=${sort}&CenterIDs=${CenterIDs}&UserTypeID=${UserTypeID}&ClassID=${ClassID}&StudentID=${StudentID}&search=${search}`
    );
  }

  getCoachDetailsByID(id: any) {
    return this.http.get<any>(`${this.api}/trainer/${id}`);
  }

  getTrainerAttendenceReport(pageno?: number, pagesize?: number, TrainerID?: string, CenterIDs?: string, StartDate?: string, EndDate?: string, IsProxy?: string) {
    return this.http.get<any>(
      `${this.api}/trainer/attendance?pageno=${pageno}&pagesize=${pagesize}&TrainerID=${TrainerID}&CenterIDs=${CenterIDs}&StartDate=${StartDate}&EndDate=${EndDate}&IsProxy=${IsProxy}`
    );
  }

  getCenterDetailsByID(id: any) {
    return this.http.get<any>(`${this.api}/center-master/${id}`);
  }

  getClassList(pageno?: number, pagesize?: number, sort?: string, CenterIDs?: string, ClassID?: string, TrainerID?: string, StudentID?: string, search?: string) {
    let params = new HttpParams();
    if (pageno !== undefined && pageno !== null) params = params.set("pageno", pageno.toString());
    if (pagesize !== undefined && pagesize !== null) params = params.set("pagesize", pagesize.toString());
    if (sort) params = params.set("sort", sort);
    if (CenterIDs) params = params.set("CenterIDs", CenterIDs);
    if (ClassID) params = params.set("ClassID", ClassID);
    if (TrainerID) params = params.set("TrainerID", TrainerID);
    if (StudentID) params = params.set("StudentID", StudentID);
    if (search) params = params.set("search", search);

    return this.http.get<any>(`${this.api}/classMaster`, { params });
  }

  getClassDetailsByID(id: any) {
    return this.http.get<any>(`${this.api}/classMaster/${id}`);
  }

  getPackageList() {
    return this.http.get<any>(`${this.api}/package-master`);
  }

  getPackageDetailsByID(id: any) {
    return this.http.get<any>(`${this.api}/package-master/${id}`);
  }

  getPackageListByActionID(ID: any, PackageAction: string, pageno?: number, pagesize?: number, sort?: string) {
    return this.http.get<any>(`${this.api}/package-master/details?ID=${ID}&PackageAction=${PackageAction}&pageno=${pageno}&pagesize=${pagesize}&sort=${sort}`);
  }

  getMenuList(pageno?: number, pagesize?: number, sort?: string) {
    return this.http.get<any>(`${this.api}/menus?pageno=${pageno}&pagesize=${pagesize}&sort=${sort}`);
  }

  GetMenuByID(id: number) {
    return this.http.get<any>(`${this.api}/menus/${id}`);
  }

  getUserList(pageno?: number, pagesize?: number, sort?: string, CenterIDs?: string) {
    return this.http.get<any>(`${this.api}/user?pageno=${pageno}&pagesize=${pagesize}&sort=${sort}&CenterIDs=${CenterIDs}`);
  }

  getUserByID(id: number) {
    return this.http.get<any>(`${this.api}/user/${id}`);
  }

  getUserTypeList() {
    return this.http.get<any>(`${this.api}/usertypemenupermission`);
  }

  GetUserTypeByID(id: number) {
    return this.http.get<any>(`${this.api}/usertypemenupermission/${id}`);
  }

  getUserAccess(id: number) {
    return this.http.get<any>(`${this.api}/user-access/${id}`);
  }

  getDashboardData(id: number) {
    return this.http.get<any>(`${this.api}/dashboard/summary/?UMID=${id}`);
  }

  getStudentCount(CenterID: string) {
    return this.http.get<any>(`${this.api}/dashboard/student-count?CenterID=${CenterID}`);
  }

  getCoachCount(CenterID: string, UserTypeID: string) {
    return this.http.get<any>(`${this.api}/dashboard/coach-count?CenterID=${CenterID}&UserTypeID=${UserTypeID}`);
  }

  getClassCount(CenterID: string, TrainerID: string) {
    return this.http.get<any>(`${this.api}/dashboard/class-count?CenterID=${CenterID}&TrainerID=${TrainerID}`);
  }

  getPaymentModeMaster() {
    return this.http.get<any>(`${this.api}/payment-through-master`);
  }

  getFinanceMaster(pageno?: number, pagesize?: number, sort?: string, CenterIDs?: string, Search?: string) {
    return this.http.get<any>(`${this.api}/student-package-subscription?pageno=${pageno}&pagesize=${pagesize}&sort=${sort}&CenterIDs=${CenterIDs}&search=${Search}`);
  }

  getFinanceMasterByID(id: number) {
    return this.http.get<any>(`${this.api}/student-package-subscription/${id}`);
  }

  getEventList() {
    return this.http.get<any>(`${this.api}/event-master/get-all`);
  }

  getEventByID(id: number) {
    return this.http.get<any>(`${this.api}/event-master/get-by-id/${id}`);
  }

  getEventRegistrationListByID(id: number) {
    return this.http.get<any>(`${this.api}/event-registrations/get-by-id/${id}`);
  }
  getDocument(url: string) {
    const endpoint = `${this.api}/documents?url=${encodeURIComponent(url)}`;
    return this.http.get(endpoint, { responseType: "text" });
  }

  getProductCompanyList() {
    return this.http.get<any>(`${this.api}/product-company-master`);
  }

  getProductCompanyByID(id: number) {
    return this.http.get<any>(`${this.api}/product-company-master/${id}`);
  }

  getProductList(pageno?: number, pagesize?: number, sort?: string) {
    return this.http.get<any>(`${this.api}/product-master?pageno=${pageno}&pagesize=${pagesize}&sort=${sort}`);
  }

  getProductByID(id: number) {
    return this.http.get<any>(`${this.api}/product-master/${id}`);
  }

  getProductSizeList() {
    return this.http.get<any>(`${this.api}/product-size-master`);
  }

  getOrdersList(pageno?: number, pagesize?: number, sort?: string, CenterID?: string) {
    return this.http.get<any>(`${this.api}/product-order-main?pageno=${pageno}&pagesize=${pagesize}&sort=${sort}&CenterID=${CenterID}`);
  }

  getOrderDetailsByID(id: number) {
    return this.http.get<any>(`${this.api}/product-order-main/${id}`);
  }

  // ge
  //#endregion

  //#region Post
  addCompany(data: any) {
    const token = sessionStorage.getItem("Token");
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    return this.http.post<any>(`${this.api}/company`, data, { headers });
  }

  addRegion(data: any) {
    const token = sessionStorage.getItem("Token");
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    return this.http.post<any>(`${this.api}/region-master`, data, { headers });
  }

  addCity(data: any) {
    const token = sessionStorage.getItem("Token");
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    return this.http.post<any>(`${this.api}/city-master`, data, { headers });
  }

  addArea(data: any) {
    const token = sessionStorage.getItem("Token");
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    return this.http.post<any>(`${this.api}/area-master`, data, { headers });
  }

  addCenter(data: any) {
    const token = sessionStorage.getItem("Token");
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    return this.http.post<any>(`${this.api}/center-master`, data, { headers });
  }

  addStudent(data: any) {
    const token = sessionStorage.getItem("Token");
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    return this.http.post<any>(`${this.api}/student`, data, { headers });
  }

  addInquiry(data: any) {
    return this.http.post<any>(`${this.api}/enquiry`, data);
  }

  addStudentPerformance(data: any) {
    const token = sessionStorage.getItem("Token");
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    return this.http.post<any>(`${this.api}/student-performance`, data, { headers });
  }

  addCoach(data: any) {
    const token = sessionStorage.getItem("Token");
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    return this.http.post<any>(`${this.api}/trainer`, data, { headers });
  }

  addPackage(data: any) {
    const token = sessionStorage.getItem("Token");
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    return this.http.post<any>(`${this.api}/package-master`, data, { headers });
  }

  addMenu(data: any) {
    const token = sessionStorage.getItem("Token");
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    return this.http.post<any>(`${this.api}/menus`, data, { headers });
  }

  addClass(data: any) {
    const token = sessionStorage.getItem("Token");
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    return this.http.post<any>(`${this.api}/classMaster`, data, { headers });
  }

  addStudentAttendance(data: any) {
    const token = sessionStorage.getItem("Token");
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    return this.http.post<any>(`${this.api}/student/attendance/upsert`, data, { headers });
  }

  addPayment(data: any) {
    const token = sessionStorage.getItem("Token");
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    return this.http.post<any>(`${this.api}/student-package-subscription`, data, { headers });
  }

  addPendingPayment(data: any) {
    const token = sessionStorage.getItem("Token");
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    return this.http.post<any>(`${this.api}/student-package-subscription/collect-pending-payment`, data, { headers });
  }

  addEvent(data: any) {
    const token = sessionStorage.getItem("Token");
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    return this.http.post<any>(`${this.api}/event-master/create`, data, { headers });
  }

  addEventRegistration(data: any) {
    const token = sessionStorage.getItem("Token");
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    return this.http.post<any>(`${this.api}/event-registrations/create`, data, { headers });
  }

  addBelt(data: any) {
    const token = sessionStorage.getItem("Token");
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    return this.http.post<any>(`${this.api}/belt-master`, data, { headers });
  }

  addProductCompany(data: any) {
    const token = sessionStorage.getItem("Token");
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    return this.http.post<any>(`${this.api}/product-company-master`, data, { headers });
  }

  addProduct(data: any) {
    const token = sessionStorage.getItem("Token");
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    return this.http.post<any>(`${this.api}/product-master`, data, { headers });
  }

  addOrder(data: any) {
    const token = sessionStorage.getItem("Token");
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    return this.http.post<any>(`${this.api}/product-order-main`, data, { headers });
  }

  addPaymentCredit(data: any) {
    const token = sessionStorage.getItem("Token");
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    return this.http.post<any>(`${this.api}/payment/add-credit`, data, { headers });
  }

  bulkUploadStudents(file: File) {
    const formData = new FormData();
    formData.append("file", file);
    const token = sessionStorage.getItem("Token");
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    return this.http.post<any>(`${this.api}/student/bulk-upload`, formData, { headers });
  }

  uploadClassDocument(data: any) {
    const token = sessionStorage.getItem("Token");
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    return this.http.post<any>(`${this.api}/student/upload-class-document`, data, { headers });
  }

  //#endregion

  //#region Put

  updateCompany(data: any, id: number) {
    const token = sessionStorage.getItem("Token");
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    return this.http.put<any>(`${this.api}/company/${id}`, data, { headers });
  }

  updateStudent(data: any, id: number) {
    const token = sessionStorage.getItem("Token");
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    return this.http.put<any>(`${this.api}/student/${id}`, data, { headers });
  }

  updateStudentAttendance(data: any, id: number) {
    const token = sessionStorage.getItem("Token");
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    return this.http.put<any>(`${this.api}/student/attendance/upsert`, data, { headers });
  }

  updateCoach(data: any, id: number) {
    const token = sessionStorage.getItem("Token");
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    return this.http.put<any>(`${this.api}/trainer/${id}`, data, { headers });
  }

  updatePackage(data: any, id: number) {
    const token = sessionStorage.getItem("Token");
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    return this.http.put<any>(`${this.api}/package-master/${id}`, data, { headers });
  }

  addMenuPermission(data: any) {
    const token = sessionStorage.getItem("Token");
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    return this.http.post<any>(`${this.api}/usertypemenupermission/assign-user-type-with-permissions`, data, { headers });
  }

  updateMenuPermission(data: any, id: number) {
    return this.http.put<any>(`${this.api}/usertypemenupermission/assign-user-type-with-permissions`, data);
  }

  updateUserAccess(data: any) {
    const token = sessionStorage.getItem("Token");
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    return this.http.post<any>(`${this.api}/usertypemenupermission/assign-user-roles`, data, { headers });
  }

  updateMenu(data: any, id: number) {
    return this.http.put<any>(`${this.api}/menus/${id}`, data);
  }

  updateClass(data: any, id: number) {
    const token = sessionStorage.getItem("Token");
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    return this.http.put<any>(`${this.api}/classMaster/${id}`, data, { headers });
  }

  updateCenter(data: any, id: number) {
    const token = sessionStorage.getItem("Token");
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    return this.http.put<any>(`${this.api}/center-master/${id}`, data, { headers });
  }

  updateRegion(data: any, id: number) {
    const token = sessionStorage.getItem("Token");
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    return this.http.put<any>(`${this.api}/region-master/${id}`, data, { headers });
  }

  updateArea(data: any, id: number) {
    const token = sessionStorage.getItem("Token");
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    return this.http.put<any>(`${this.api}/area-master/${id}`, data, { headers });
  }

  updateEvent(data: any, id: number) {
    const token = sessionStorage.getItem("Token");
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    return this.http.put<any>(`${this.api}/event-master/update/${id}`, data, { headers });
  }

  updateBelt(data: any, id: number) {
    const token = sessionStorage.getItem("Token");
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    return this.http.put<any>(`${this.api}/belt-master/${id}`, data, { headers });
  }

  updateProductCompany(data: any, id: number) {
    const token = sessionStorage.getItem("Token");
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    return this.http.put<any>(`${this.api}/product-company-master/${id}`, data, { headers });
  }

  updateProduct(data: any, id: number) {
    const token = sessionStorage.getItem("Token");
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    return this.http.put<any>(`${this.api}/product-master/${id}`, data, { headers });
  }

  updateOrderStatus(data: any, id: number) {
    const token = sessionStorage.getItem("Token");
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    return this.http.put<any>(`${this.api}/product-order-main/${id}`, data, { headers });
  }

  updateOrderItemStatus(data: any, id: number) {
    const token = sessionStorage.getItem("Token");
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    return this.http.put<any>(`${this.api}/product-order-main/details/${id}/status`, data, { headers });
  }

  updateEventRegistration(data: any, id: number) {
    const token = sessionStorage.getItem("Token");
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    return this.http.put<any>(`${this.api}/event-registrations/update/${id}`, data, { headers });
  }

  assignProxyTrainer(data: any) {
    const token = sessionStorage.getItem("Token");
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    return this.http.post<any>(`${this.api}/trainer/set-proxy`, data, { headers });
  }

  markTrainerAttendance(data: any) {
    const token = sessionStorage.getItem("Token");
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    return this.http.post<any>(`${this.api}/trainer/mark-attendance`, data, { headers });
  }
  //#endregion

  deleteAttendance(StudentID: number, ClassID: number, AttendanceDate: string) {
    return this.http.delete(`${this.api}/student/delete`, {
      params: { StudentID, ClassID, AttendanceDate },
    });
  }

  // http://localhost:3000/api/student/delete?StudentID=2&ClassID=1&AttendanceDate=2025-10-09
}
